import { newsLetterSubscription } from '@/app/api/subscribe'
import { useMutation } from '@tanstack/react-query'

interface NewsletterSubscriptionParams {
	email: string
	lang: string
}

export const useNewsletterSubscription = () => {
	return useMutation({
		mutationFn: ({ email, lang }: NewsletterSubscriptionParams) =>
			newsLetterSubscription(email, lang),
		onError: (error) => {
			console.error('Newsletter subscription failed:', error)
		},
	})
}
